// src/components/BandMembers/BandMembers.jsx
import React from "react";

import samuliImg from "../../assets/samuli.webp";
import jereImg from "../../assets/jere.webp";
import teemuImg from "../../assets/teemu.webp";
import arttuImg from "../../assets/arttu.webp";

const members = [
  {
    name: "Samuli",
    role: "Laulu",
    image: samuliImg,
    memory:
      "Paras keikkamuisto on varmaan keikka Poliisien kesäkodilla Lauttasaaressa – siinä ei oltu juhlabudjetissa säästelty!",
    favorite:
      "Oasiksen Don’t Look Back in Anger tai vanha kunnon Tinakenkätyttö.",
    best:
      "Joyridessa parasta on asenne, rokkimeininki ja se, että keikalle mennessä on aina rento fiilis."
  },
  {
    name: "Jere",
    role: "Kitara, taustalaulu",
    image: jereImg,
    memory:
      "Erään parkkifirman vuosijuhlat – kerrankin parkkihallista selvisi ilmaiseksi.",
    favorite:
      "Biisit, joissa yleisö on kunnolla messissä. Viime aikoina suosikki on ollut Ihmisten edessä.",
    best:
      "Yhteishenki ja livemeininki. On hauskaa soittaa yhdessä ja tarjota sama fiilis myös yleisölle."
  },
  {
    name: "Taisto",
    role: "Basso, taustalaulu",
    image: teemuImg,
    memory:
      "Järvenrantahuvilan keikalla lavan vieressä oli takka. Viimeisessä setissä grillattiin makkaraa samalla, kun soitimme yleisölle Abbaa.",
    favorite:
      "Kersantti Karoliina ja Paranoid – ne toimivat yleisölle aina.",
    best:
      "Kokemus ja rentous. Vaikka keikalla tapahtuisi mitä, lavalla pysyy hyvä fiilis."
  },
  {
    name: "Arttu",
    role: "Rummut",
    image: arttuImg,
    memory:
      "Lappeenrannan keikalla rumpukapula kimposi hi-hatista suoraan silmään. Näkö sumeni hetkeksi, mutta setti vedettiin loppuun.",
    favorite:
      "Biisit, joissa pääsee heittämään tuplia ja nostamaan fiilistä.",
    best:
      "Kokemus näkyy siinä, että lavalla voi luottaa jokaiseen soittajaan."
  }
];

const BandMembers = () => {
  return (
    <section className="w-full bg-gray-100 py-16 md:py-20 dark:bg-joyrideNavy">
      <div className="mx-auto max-w-6xl px-4">
        <div className="mb-10 text-center">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.25em] text-joyridePurple dark:text-joyrideCyan">
            Joyriden jäsenet
          </p>

          <h2 className="font-lobster text-4xl text-joyridePurple dark:text-joyrideCyan dark:text-shadow-lg">
            Keitä lavalla nähdään?
          </h2>

          <p className="mx-auto mt-4 max-w-2xl text-base text-joyrideNavy/80 dark:text-joyrideLight/80">
            Tutustu Joyriden jäseniin.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {members.map((member) => (
            <div key={member.name}>
              {/* Desktop: flip-kortti */}
              <div className="group hidden h-[540px] [perspective:1200px] lg:block">
                <article className="relative h-full w-full transition-transform duration-700 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">
                  <div className="absolute inset-0 overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-black/10 [backface-visibility:hidden] dark:bg-white/10 dark:ring-white/10">
                    <div className="bg-[#746397]">
                      <img
                        src={member.image}
                        alt={`${member.name}, Bilebändi Joyride`}
                        className="h-96 w-full object-contain object-bottom transition duration-500 group-hover:scale-105"
                        loading="lazy"
                        width="500"
                        height="700"
                      />
                    </div>

                    <div className="px-5 py-7 text-center">
                      <h3 className="font-lobster text-3xl text-joyridePurple dark:text-joyrideCyan">
                        {member.name}
                      </h3>

                      <p className="mt-1 text-base font-semibold text-joyrideNavy dark:text-joyrideLight">
                        {member.role}
                      </p>
                    </div>
                  </div>

                  <div className="absolute inset-0 overflow-hidden rounded-3xl bg-white p-6 shadow-xl ring-1 ring-black/10 [transform:rotateY(180deg)] [backface-visibility:hidden] dark:bg-white/10 dark:ring-white/10">
                    <span
                      aria-hidden="true"
                      className="pointer-events-none absolute -top-4 left-4 font-serif text-8xl leading-none text-joyrideCyan/15 transition duration-500 group-hover:text-joyrideCyan/25"
                    >
                      ”
                    </span>

                    <div className="relative z-10 flex h-full flex-col">
                      <div className="mb-4 text-center">
                        <h3 className="font-lobster text-3xl text-joyridePurple dark:text-joyrideCyan">
                          {member.name}
                        </h3>
                        <p className="mt-1 text-sm font-semibold uppercase tracking-[0.2em] text-joyrideNavy/70 dark:text-joyrideLight/70">
                          {member.role}
                        </p>
                      </div>

                      <div className="space-y-4 text-sm leading-relaxed text-joyrideNavy dark:text-joyrideLight">
                        <div>
                          <p className="font-bold text-joyridePurple dark:text-joyrideCyan">
                            Hauskin keikkamuisto
                          </p>
                          <p>{member.memory}</p>
                        </div>

                        <div>
                          <p className="font-bold text-joyridePurple dark:text-joyrideCyan">
                            Lempibiisi livenä
                          </p>
                          <p>{member.favorite}</p>
                        </div>

                        <div>
                          <p className="font-bold text-joyridePurple dark:text-joyrideCyan">
                            Joyridessa parasta
                          </p>
                          <p>{member.best}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              </div>

              {/* Mobiili/tablet: ei flippiä */}
              <article className="overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-black/10 lg:hidden dark:bg-white/10 dark:ring-white/10">
                <div className="bg-[#746397]">
                  <img
                    src={member.image}
                    alt={`${member.name}, Bilebändi Joyride`}
                    className="h-96 w-full object-contain object-bottom"
                    loading="lazy"
                    width="500"
                    height="700"
                  />
                </div>

                <div className="p-6">
                  <div className="mb-5 text-center">
                    <h3 className="font-lobster text-3xl text-joyridePurple dark:text-joyrideCyan">
                      {member.name}
                    </h3>

                    <p className="mt-1 text-base font-semibold text-joyrideNavy dark:text-joyrideLight">
                      {member.role}
                    </p>
                  </div>

                  <div className="space-y-4 text-sm leading-relaxed text-joyrideNavy dark:text-joyrideLight">
                    <div>
                      <p className="font-bold text-joyridePurple dark:text-joyrideCyan">
                        Hauskin keikkamuisto
                      </p>
                      <p>{member.memory}</p>
                    </div>

                    <div>
                      <p className="font-bold text-joyridePurple dark:text-joyrideCyan">
                        Lempibiisi livenä
                      </p>
                      <p>{member.favorite}</p>
                    </div>

                    <div>
                      <p className="font-bold text-joyridePurple dark:text-joyrideCyan">
                        Joyridessa parasta
                      </p>
                      <p>{member.best}</p>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BandMembers;